

export interface ReportTemplate {
	id: number;
	name: string;
	description: string;
	body: string;
	created_at: Date;
	updated_at: Date;
}

export const defaultTemplate = {
	id: 0,
	name: "",
	description: "",
	body: "",
	created_at: new Date(),
	updated_at: new Date(),
};
